import {
  COMPACT_DIFF_LINES_NOTICE_NAME,
  DiffCompactLinesPopover,
} from '@github-ui/diff-view-settings/components/DiffCompactLinesPopover'

import {useDismissNotice} from '../../mutations/use-dismiss-notice'
import {useIsNoticeDismissed} from '../../stores/layout-selectors'

/**
 * Wires the shared {@link DiffCompactLinesPopover} to the pull-requests notice
 * store/mutation. Kept as its own component so the `compact_diff_lines` notice
 * subscription stays scoped here: dismissing the notice re-renders only this
 * wrapper, not the surrounding toolbar.
 */
export function CompactDiffLinesNotice() {
  const isNoticeDismissed = useIsNoticeDismissed(COMPACT_DIFF_LINES_NOTICE_NAME)
  const {dismissNotice} = useDismissNotice(COMPACT_DIFF_LINES_NOTICE_NAME)
  return <DiffCompactLinesPopover isNoticeDismissed={isNoticeDismissed} onDismissNotice={dismissNotice} />
}
